// :module,
// :period,
// :cycle,
// :scenario,
// :costcenter,
// :location,
// :asofdate,

export const eventsbasic = {

  alertseverity: {
    service:{
      name:'alertseverity',
      title:'Alert Severity',
    }
  },

  alertstate: {
    service:{
      name:'alertstate',
      title:'Alert State',
    }
  },

  announcestate: {
    service:{
      name:'announcestate',
      title:'Announcement State',
    }
  },

  appservice: {
    service:{
      name:'appservice',
      title:'App Service',
    }
  },

  audience: {
    service:{
      name:'audience',
      title:'Audience',
    }
  },

  eventstate: {
    service:{
      name:'eventstate',
      title:'Event State',
    }
  },

  eventtype: {
    service:{
      name:'eventtype',
      title:'Event Type',
    }
  },

  serviceaction: {
    service:{
      name:'serviceaction',
      title:'Service Action',
    }
  },

  supportpriority: {
    service:{
      name:'supportpriority',
      title:'Support Priority',
    }
  },

  supportstate: {
    service:{
      name:'supportstate',
      title:'Support State',
    }
  },

  topicchannel: {
    service:{
      name:'topicchannel',
      title:'Topic Channel',
    }
  },

  topicscope: {
    service:{
      name:'topicscope',
      title:'Topic Scope',
    }
  },
};
